import { createFileRoute } from '@tanstack/react-router';
import { JourneysBroadcastIndexHandoff } from '@/pages/workspaces/broadcasts/broadcast/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/',
)({
  component: JourneysBroadcastIndexHandoff,
});
